import { render } from "./ImageSlides.vue?vue&type=template&id=fb50760a&scoped=true&ts=true"
import script from "./ImageSlides.vue?vue&type=script&lang=ts"
export * from "./ImageSlides.vue?vue&type=script&lang=ts"

import "./ImageSlides.vue?vue&type=style&index=0&id=fb50760a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/bakery-platform/bakery-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb50760a"]])

export default __exports__